jQuery(window).on("load", function(){
  // Select the first variant by default
  enableAddToCart();
});
jQuery(document).ready(function(){
  // Select the first variant by default
  initSubscription();

  jQuery(document).on("click", ".header-icons-block__search, .custom_search__input_field__input", function(){
    jQuery("#header--search__container").toggleClass("active_search");
  });
  
  jQuery(document).on("click", ".bottom-bar .bottom-bar-flex a.flex-item:nth-child(2)", function(e){
    e.preventDefault();
    jQuery("#Details-menu-drawer-container summary.header__icon.header__icon--menu.header__icon--summary.link.focus-inset").click();
  });

});


function enableAddToCart(){
  jQuery(".single_product:nth-child(2) input").click();
 const monthlySubscriptionInput = document.querySelector('.current_product_subscription:not(.no-subscription) input');
  // console.log("monthlySubscriptionInput", monthlySubscriptionInput)
if (monthlySubscriptionInput) {
  setTimeout(function(){
  monthlySubscriptionInput.click();
}, 1000);
}
  setTimeout(function(){
    jQuery(".product-form__submit, .buy-now").removeAttr("disabled").addClass("active");
  }, 500);
}

function initSubscription(){
   jQuery(".single_product:first-child input").click();

  jQuery(document).on("click", ".single_product", function() {
      jQuery(".thumbnail-list, .product__media-list").find("li:first-child").css({ "opacity": 0 });

      jQuery(this).closest(".product__info-container").find('input[name="selling_plan"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-selling-plan-id") );
      jQuery(this).closest(".product__info-container").find('input[name="id"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-variant-id") );
      jQuery(this).closest(".product__info-container").find('input[name="product-id"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-product-id") );
      jQuery(this).closest(".product__info-container").find('input[name="addons_ids"]').val( jQuery(this).find(".selling_plan_vavaverve").attr("data-product-addons") );

      // get the product image on which subscription plan we've clicked
      var product_image = jQuery(this).attr("product-image");
      // update the very first thumbnail and gallery src
      jQuery(".thumbnail-list, .product__media-list").each(function(){
          jQuery(this).find("li:first-child img").attr("src", product_image).attr("srcset", product_image);
          jQuery(".product-media-modal__content").find("img:first-child").attr("src", product_image).attr("srcset", product_image);
          setTimeout(function(){
            jQuery(".thumbnail-list, .product__media-list").find("li:first-child").css({ "opacity": 1 });
          }, 300);
      });
    
      // Click Event to active the block
      jQuery(".single_product").removeClass("rc_block_active");
      var thisItem = jQuery(this);
      setTimeout(function(){
          if ( thisItem.find("input").is(":checked") == true ) {
          thisItem.addClass("rc_block_active");
      } else {
          thisItem.removeClass("rc_block_active");
      }
      }, 100)
  });
}

// document.addEventListener("DOMContentLoaded", function () {
//   // Use a more specific selector to target the Monthly Subscription input
//   enableAddToCart()
// });
